angular.module('ApptBookApp').controller('BlockAuditLogController', [
    '$scope', 
    '$http', 
    '$rootScope',
    '$translate', 
    'restServer',
    'appointmentBookModalService',
    'blockId', 
    'meevo.components.busy.BusyService',
    'meevo.AppSettings',
    '$sce',
    (
        $scope,
        $http,
        $rootScope,
        $translate: ng.translate.ITranslateService,
        restServer,
        modal,
        blockId,
        busyService: Meevo.Components.Busy.IBusyService,
        appSettings: Meevo.Components.Common.IAppSettings,
        $sce: angular.ISCEService
    ) => {
        $scope.modal = modal;
        $scope.service = [];
        $scope.isBlockAuditHistory = !!blockId;
        $scope.auditRowClicked = (ev) => {
            let blockScheduleId = $(ev.target).data("block-schedule-id");
            if (blockScheduleId) {
                modal.hideModal();
                var stateParams = {
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: blockScheduleId,
                };

                $rootScope.$broadcast("gotoState", {
                    stateName: appSettings.ROUTE_NAMES.standingBlocks,
                    stateParams: stateParams
                });
            }
        }
        if (blockId != undefined) {
			restServer.getBlockAuditHistory(blockId, appSettings, (blockChanges: Meevo.Model.IBlockAuditLog[]) => {
                
                for (var blockChange of blockChanges) {
                    var preparedChange: any = blockChange;
                    preparedChange.actions = [];

                    var translatedVerb = $translate.instant(`LABEL_${Meevo.Model.VerbEnum[blockChange.verb].toUpperCase()}`);
                    var standingText = blockChange.isStandingBlock ? ` (<span class="transeditor-link" data-block-schedule-id="${blockChange.blockScheduleId}">${$translate.instant('LABEL_STANDING')}</span>)` : '';
                    preparedChange.actions.push(`${blockChange.blockTypeDisplayName}${standingText} ${translatedVerb}.`);
                    
                    for (var changeEntry of blockChange.entries) {
                        if (blockChange.verb === Meevo.Model.VerbEnum.Updated) {

                            var hasOldValue = changeEntry.oldValue && changeEntry.oldValue.length > 0;
                            var hasNewValue = changeEntry.newValue && changeEntry.newValue.length > 0;
                            var removed = hasOldValue && !hasNewValue;
                            var added = !hasOldValue && hasNewValue;
                            var blockTypeUpdated = !hasOldValue && !hasNewValue;
                            
                            var updatedEntryVerbTextKey = removed 
                                ? 'LABEL_REMOVED'
                                : added 
                                    ? 'LABEL_ADDED_AS'
                                    : blockTypeUpdated
                                        ? 'LABEL_UPDATED'
                                        : 'LABEL_CHANGED_TO';
                            
                            var updatedEntryVerbText = $translate.instant(updatedEntryVerbTextKey);

                            var newValueText = changeEntry.newValue || "";

                            preparedChange.actions.push(`${changeEntry.propertyName} ${updatedEntryVerbText} ${newValueText}`);
                            continue;
                        }
                        
                        preparedChange.actions.push(` ${changeEntry.propertyName}: ${changeEntry.newValue}.`);
                    }
                    
                    preparedChange.actions = [$sce.trustAsHtml(preparedChange.actions.join(" "))];
                    $scope.service.push(preparedChange);
                }
            });
        } else {
            busyService.stop();
        }
    }
]);
